import React from "react";
import { Route, Routes } from "react-router-dom";
import { CompanyLogo } from "../assets/icons";
import {
  AuthWrapper,
  AuthContainer,
  AuthLogoSection,
  CompanyName,
  PortalSubtitle,
  PoweredBy,
  PoweredByBold,
} from "./index.styles";
import LoginForm from "./components/LoginForm";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import AcceptInvite from "./components/AcceptInvite";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { selectPortalContext } from "../../../store/slice/portalContextSlice";
import PortalAuthRedirect from "./PortalAuthRedirect";

const PortalAuth = () => {
  const { subdomain } = useParams();
  const portalContext = useSelector(state => selectPortalContext(state, subdomain));
  const portalName = portalContext?.name || "Company Name";

  return (
    <AuthWrapper>
      <AuthContainer>
        <AuthLogoSection>
          <CompanyLogo />
          <CompanyName>{portalName}</CompanyName>
          <PortalSubtitle>B2B Customer Portal</PortalSubtitle>
        </AuthLogoSection>

        <Routes>
          <Route element={<PortalAuthRedirect />}>
            <Route path="login" element={<LoginForm />} />
            <Route path="forgot_password" element={<ForgotPassword />} />
          </Route>
          <Route path="reset_password" element={<ResetPassword />} />
          <Route path="accept_invite" element={<AcceptInvite />} />
        </Routes>

        <PoweredBy>
          Powered by <PoweredByBold>Orderlink</PoweredByBold>
        </PoweredBy>
      </AuthContainer>
    </AuthWrapper>
  );
};

export default PortalAuth;
